import React from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'

export enum InputContainerBackground {
  transparent = 'transparent',
  gray = 'gray'
}

export interface BorderColor {
  default?: string
  error?: string
  focus?: string
}

export interface IInputContainerProps {
  children?: React.ReactNode
  errorIntlKey?: string
  background: InputContainerBackground
  borderColor?: BorderColor
}

const InputContainer: React.FC<IInputContainerProps> = ({ children, errorIntlKey, background, borderColor }) => {
  const intl = useIntl()

  let classes: string = background
  if (errorIntlKey) {
    classes += ' error'
  }

  return (
    <Container>
      <InputArea className={classes} borderColor={borderColor}>
        {children}
      </InputArea>
      {errorIntlKey && <ErrorLabel>{intl.formatMessage({ id: errorIntlKey })}</ErrorLabel>}
    </Container>
  )
}

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`

interface InputAreaProps {
  borderColor?: BorderColor
}

const InputArea = styled.div<InputAreaProps>`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 12px;
  gap: 12px;
  border: 0.1rem solid ${({ theme, borderColor }) => (borderColor && borderColor.default) || theme.color.borderGrey};
  border-radius: 4px;
  align-content: stretch;
  margin-top: 8px;
  position: relative;

  &:focus {
    border: 0.1rem solid ${({ theme, borderColor }) => (borderColor && borderColor.focus) || theme.color.borderGrey};
  }

  &.error {
    border: 0.1rem solid ${({ theme, borderColor }) => (borderColor && borderColor.error) || theme.color.error};
  }

  &.transparent {
    background: transparent;
  }
  &.gray {
    background: #d0d0d0;
  }
`

const ErrorLabel = styled.div`
  color: ${({ theme }) => theme.color.error};
`

export default InputContainer
